import Modal from './modal';
// import { method } from './events';
// Modal.success = method('success')
export default Modal;
